import type { LinkValue } from '@elfsight/configurator-contracts';
import {
  ButtonBlock,
  type ButtonBlockProps
} from '@elfsight/widget-banner/widget';
import { useSettings } from '@wu/widget-core';
import type { ClickAction } from '../../types';
import { usePopup } from '../../utils';

type ButtonProps = ButtonBlockProps & {
  clickAction: ClickAction;
};

export function Button({
  clickAction,
  buttonProps,
  link: derivedLink,
  ...forwardingProps
}: ButtonProps) {
  const { editMode } = useSettings();
  const { close } = usePopup();

  let link: LinkValue | undefined = undefined;
  if (clickAction === 'redirect') {
    link = derivedLink;
  }
  if (link) {
    link.target = editMode ? '_blank' : link.target;
  }

  const closeHandler = () => {
    if (clickAction === 'closePopup') {
      close();
    }
  };

  return (
    <ButtonBlock
      {...forwardingProps}
      link={link}
      buttonProps={{
        ...buttonProps,
        onClick: closeHandler
      }}
    />
  );
}
